var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.superior") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.houseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "houseCode", $$v)
                      },
                      expression: "childData.houseCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.repairType") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.repairType,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "repairType", $$v)
                      },
                      expression: "childData.repairType"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.urgencyDegree") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.situationType,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "situationType", $$v)
                      },
                      expression: "childData.situationType"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.childData.rType === 2
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.repairDevice") } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { type: "text", disabled: "" },
                        model: {
                          value: _vm.childData.deviceName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "deviceName", $$v)
                          },
                          expression: "childData.deviceName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.childData.rType === 1
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.source") } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { type: "text", disabled: "" },
                        model: {
                          value: _vm.childData.repairSource,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "repairSource", $$v)
                          },
                          expression: "childData.repairSource"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.workOrderType") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.orderType,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "orderType", $$v)
                      },
                      expression: "childData.orderType"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.classWorkList") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.orderSubType,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "orderSubType", $$v)
                      },
                      expression: "childData.orderSubType"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("table.contactMan"), prop: "areaName" }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.contact,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "contact", $$v)
                      },
                      expression: "childData.contact"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.contactNumber") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "phone", _vm._n($$v))
                      },
                      expression: "childData.phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.reservation") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.handleTime,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "handleTime", $$v)
                      },
                      expression: "childData.handleTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.installPosition") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.childData.deviceAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "deviceAddress", $$v)
                      },
                      expression: "childData.deviceAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.repairDetail") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: {
                      disabled: "",
                      type: "textarea",
                      autosize: { minRows: 3, maxRows: 3 }
                    },
                    model: {
                      value: _vm.childData.content,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "content", $$v)
                      },
                      expression: "childData.content"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("h3", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("图片附件")
          ]),
          _c("el-upload", {
            staticClass: "picDetail",
            attrs: {
              action: "",
              "auto-upload": false,
              "file-list": _vm.fileList,
              "list-type": "picture-card",
              "show-file-list": true,
              "on-preview": _vm.handlePictureCardPreview
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, title: "图片", width: "700px" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      ),
      _c("h3", { staticStyle: { "margin-bottom": "10px" } }, [
        _vm._v("派工详情")
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.opTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.opDate))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作人" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.userName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.remark"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.remark ? scope.row.remark : "无"))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.finishTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.finishTime))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.performance") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.statusValue))])]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }